import React, { useEffect, useState } from "react";
import MainCard from "./profile/MainCard";
import { translation } from "../translation";
import { useSelector } from "react-redux";
import useCollaboratorRestriction from "../hooks/useCollaboratorRestriction";

const LogoutAnimation = ({ onHide }) => {
  const lang = useSelector(
    (state) => state.collaborator.collaboratorInfo.language,
  );
  const user = useSelector((state) => state.collaborator.collaboratorInfo);
  const config = useCollaboratorRestriction();
  const hasCover =
    Boolean(user?.cover?.url) || Boolean(config?.cover?.url);
  const headerHeightClass = hasCover
    ? "h-[255px] md:h-[280px]"
    : "h-[220px]";
  const [popup, setPopup] = useState({ transform: "rotate(33deg)" });

  const swiperCard = () => {
    setPopup({ transform: "none" });
    setTimeout(() => {
      setPopup({ transform: "rotate(33deg)" });
    }, 300);
  };

  useEffect(() => {
    const initial = setTimeout(swiperCard, 400);
    const interval = setInterval(swiperCard, 5000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[99999] bg-black/90">
      <div className="mx-auto flex h-full w-full max-w-[580px] flex-col px-5">
        <div
          className={`${headerHeightClass} shrink-0`}
          aria-hidden="true"
        />
        <div className="relative z-10 -mt-[115px]">
          <MainCard infinite_animation={true} />
        </div>

        <div className="mt-10 flex flex-col items-center px-2 text-white">
          <img
            style={popup}
            src="../../assets/img/icons/hand-swipe.svg"
            id="icon-swipe"
            alt=""
          />
          <p className="mt-5 max-w-[286px] text-center text-[19px] tracking-[-.89px]">
            {translation?.logoutAnim?.title?.[lang]}
          </p>
          <button
            type="button"
            className="mt-8 cursor-pointer rounded-md border border-white/80 bg-transparent px-10 py-2.5 text-[15px] transition-colors hover:bg-white/10"
            onClick={onHide}
          >
            {translation?.logoutAnim?.button?.[lang]}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutAnimation;
